import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import React from "react";
import ReactDOM from "react-dom";
import { CookieStorage } from "cookie-storage";
import ChaseTableList from "./components/chase/ChaseTableList";
import InactiveList from "./components/inactiveList";
import RecentMessages from "./components/MessagesAudit/RecentMessages";
import PlayerAnalysisForm from "./components/playerAnalysis/PlayerAnalysisForm";
import GameScoreReportForm from "./components/gameScoreReport/GameScoreReportForm";
import ClonePlayerDialog from "./components/clonePlayer/ClonePlayerDialog";
import PlayerManagement from "./components/playerManagement/PlayerManagement";
import ReportAdjustment from "./components/reportAdjustment/ReportAdjustment";
import Rollout from "./components/rollout";
import AgentConfig from "./components/agentConfig";
// import TokenTimeoutDialog from "./components/TokenTimeoutDialog";
import ActiveUsers from "./components/ActiveUsers";

import constants from "./util/constants";
import MorphAgent from "./util/morphAgent";
import interceptors from "./util/interceptors";

const cookieStorage = new CookieStorage();

if (cookieStorage.getItem(constants.URL_SERVICE) === "service.localhost") {
  constants.API_URL = `//service.sportsbookvip.com/api/Gateway?command=`;
} else {
  constants.API_URL = `//${cookieStorage.getItem(
    constants.URL_SERVICE
  )}/api/Gateway?command=`;
}
if (window.location.href.includes("14.10")) {
  if (window.location.port.includes("802")) {
    constants.API_URL = `http://${
      window.location.hostname
    }:${window.location.port.replace("802", "803")}/api/Gateway?command=`;
  }
  if (window.location.port.includes("120")) {
    constants.API_URL = `http://${
      window.location.hostname
    }:${window.location.port.replace("120", "130")}/api/Gateway?command=`;
  }
  if (window.location.port.includes("220")) {
    constants.API_URL = `http://${
      window.location.hostname
    }:${window.location.port.replace("220", "230")}/api/Gateway?command=`;
  }
}
// constants.API_URL = `http://localhost:62244/api/Gateway?command=`;
/* document.addEventListener("DOMContentLoaded", () => {
  if (document.body.contains(document.getElementById("tokenTimeoutDialog"))) {
    ReactDOM.render(
      React.createElement(TokenTimeoutDialog, {}),
      document.getElementById("tokenTimeoutDialog")
    );
  }
});*/

interceptors.setupInterceptors();

const generateWidget = (widgetName, widgetElement) => ({
  [widgetName]: {
    generate: ({ selector }) => ({
      render: (props) => {
        ReactDOM.render(
          React.createElement(widgetElement, props),
          document.querySelector(selector)
        );
      },
    }),
  },
});
export default {
  UtilList: {
    MorphAgent,
  },
  WidgetList: {
    ...generateWidget("PlayerManagement", PlayerManagement),
    ...generateWidget("PlayerAnalysisForm", PlayerAnalysisForm),
    ...generateWidget("ClonePlayerDialog", ClonePlayerDialog),
    ...generateWidget("GameScoreReportForm", GameScoreReportForm),
    ...generateWidget("ReportAdjustment", ReportAdjustment),
    ...generateWidget("ChaseTableList", ChaseTableList),
    ...generateWidget("RecentMessages", RecentMessages),
    ...generateWidget("InactiveList", InactiveList),
    ...generateWidget("AgentConfig", AgentConfig),
    ...generateWidget("ActiveUsers", ActiveUsers),
    ...generateWidget("Rollout", Rollout),
  },
};
